"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SANDBOX = exports.MIDAS_COUNTRY = exports.LANG = exports.injectGuid = exports.COUNTRY = exports.APPIDS = exports.APPID = exports.APP_VERSION = void 0;
var vft_atom_1 = __importDefault(require("@tencent/vft-atom"));
var cookie_1 = __importDefault(require("@tencent/vft-common/cookie"));
var env_1 = __importDefault(require("@tencent/vft-common/env"));
var request_1 = require("@tencent/vft-common/request");
var logger_1 = __importDefault(require("../utils/logger"));
var appid_1 = __importStar(require("./appid"));
exports.APPID = appid_1.default;
Object.defineProperty(exports, "APPIDS", { enumerable: true, get: function () { return appid_1.APPIDS; } });
var country_1 = require("./country");
Object.defineProperty(exports, "COUNTRY", { enumerable: true, get: function () { return country_1.COUNTRY; } });
Object.defineProperty(exports, "MIDAS_COUNTRY", { enumerable: true, get: function () { return country_1.MIDAS_COUNTRY; } });
var lang_1 = __importDefault(require("./lang"));
exports.LANG = lang_1.default;
var sandbox_1 = __importDefault(require("./sandbox"));
exports.SANDBOX = sandbox_1.default;
// APP版本号
var matchVersion = navigator.userAgent.match(/WeTVBrowser\/(\d+(\.\d+)*)/);
var APP_VERSION = (matchVersion === null || matchVersion === void 0 ? void 0 : matchVersion[1]) ? matchVersion[1] : '';
exports.APP_VERSION = APP_VERSION;
var oneYearExpires = (new Date(Date.now() + 60 * 60 * 24 * 365 * 1000)).toUTCString();
var cache;
var guid = cookie_1.default.get('guid');
// 注入guid到cookie，query_vipinfo_international和get_autopay_status_ie要用
function injectGuid(guidKeyInCookie) {
    if (guidKeyInCookie === void 0) { guidKeyInCookie = 'guid'; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, appGuid, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // wetv里cookie的key是16位的，不符合后端规定
                    if (guidKeyInCookie !== 'guid') {
                        guid = cookie_1.default.get(guidKeyInCookie);
                    }
                    if (guid) {
                        return [2 /*return*/, guid];
                    }
                    if (!(env_1.default.isApp && (guidKeyInCookie === 'guid'))) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, vft_atom_1.default.getDeviceInfo()];
                case 2:
                    _a = (_b.sent()).guid, appGuid = _a === void 0 ? '' : _a;
                    guid = appGuid;
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    logger_1.default.error(error_1);
                    return [3 /*break*/, 4];
                case 4:
                    if (!(!guid && cache)) return [3 /*break*/, 5];
                    guid = cache.guid;
                    return [3 /*break*/, 7];
                case 5:
                    if (!!guid) return [3 /*break*/, 7];
                    return [4 /*yield*/, request_1.request('//hwvip.wetv.vip/rpc/trpc.long_link_group.inter_long_link_intl.InterLongLinkIntl/CreateGuidIntl?rpc_data={}&otype=xjson', null, {})];
                case 6:
                    cache = _b.sent();
                    guid = cache.guid;
                    cache = null;
                    _b.label = 7;
                case 7:
                    cookie_1.default.set(guidKeyInCookie, guid, { domain: '.wetv.vip', expires: oneYearExpires, path: '/' });
                    return [2 /*return*/, guid];
            }
        });
    });
}
exports.injectGuid = injectGuid;
